module.exports = __webpack_public_path__ + "static/img/timg.c803e85e.jpg";